<template>
 <v-col :cols="col" :sm="mdcol" class="sponsor-image" >
    <a :href="link" target="_blank">  
      <v-card elevation="0" >
        <v-img
          :alt="name"
          class="white"
          contain
          :src="require('../../assets/sponsors23/'+logo)"
          width="100%"
        > 
          <v-row class="overlay" no-gutters align="center" >
            <v-col align="center">
              <v-icon color="white" large>mdi-open-in-new</v-icon>
            </v-col>
          </v-row>
        </v-img>
        <v-card-title class="py-2 px-1">
          <h6 class="wdgt-subtitle liiblack--text text--lighten-1 mb-0 sponsor-name">{{name}}</h6>
        </v-card-title>
      </v-card>
    </a> 
  </v-col>
</template>


<script>
  export default {
    name:'SponsorCard',
    props:{           
      name: String, //sponsor name
      logo: String, //logo path
      link: String, //link to donor
      mdcol: String,
      col: String,
    },
  }
</script>


<style scoped>
  a{
    text-decoration: none;
  }

  .sponsor-image:hover ::v-deep a{
    text-decoration: underline;
    text-underline-offset: 1px;
    color: var(--v-liiblack-lighten2);
  }

  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    background-blend-mode: color-burn;
    transition: .3s ease;
    background-color: transparent;
  }
  .sponsor-image:hover .overlay {
    opacity: 1;
    background-color: rgba(142, 0, 18, 0.3);
  }

  .sponsor-name{
    line-height: 1.15em;
  }
</style>